document.querySelectorAll('.template-product [data-add-btn]').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();

    const target = document.querySelector('.product-add-to-cart-container #AddToCart');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });

      setTimeout(() => target.click(), 500);
    }
  });
});
